// src/components/settings/SettingsCover.jsx
import React, { useState } from "react";
import { getProfile, updatePortada } from "../Stores/profileStore";

const SettingsCover = () => {
  const baseProfile = getProfile();
  const [cover, setCover] = useState(baseProfile.portadaUrl || null);
  const [message, setMessage] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      const dataUrl = evt.target?.result;
      if (typeof dataUrl === "string") {
        updatePortada(dataUrl);
        setCover(dataUrl);
        setMessage("Imagen de portada actualizada (demo).");
      }
    };
    reader.readAsDataURL(file);
  };

  return (
    <div className="profile-settings">
      <div className="profile-header-title">
        <h1>Imagen de portada</h1>
      </div>

      <div className="cover-settings">
        <div className="cover-preview">
          {cover ? (
            <img src={cover} alt="Portada" className="cover-image" />
          ) : (
            <div className="cover-placeholder">
              <span>Sin portada</span>
            </div>
          )}
        </div>

        <div className="cover-actions">
          <p className="cover-help-text">
            Sube una imagen que se mostrará como portada en tu perfil.
          </p>
          <label className="qe-btn qe-btn-secondary">
            Seleccionar imagen
            <input
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
          </label>
        </div>
      </div>

      {message && (
        <div className="profile-message profile-message-success">
          {message}
        </div>
      )}
    </div>
  );
};

export default SettingsCover;
